/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Hub_LedeInputs */

const en_legal_hub_lede = /** @type {(inputs: Legal_Hub_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The documents that apply when you use Complete Athlete, and how to reach us.`)
};

const pl_legal_hub_lede = /** @type {(inputs: Legal_Hub_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty, które obowiązują, gdy korzystasz z Complete Athlete, oraz sposób kontaktu z nami.`)
};

/**
* | output |
* | --- |
* | "The documents that apply when you use Complete Athlete, and how to reach us." |
*
* @param {Legal_Hub_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_hub_lede = /** @type {((inputs?: Legal_Hub_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Hub_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_hub_lede(inputs)
	return en_legal_hub_lede(inputs)
});